/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { memo } from "react";
import { useDispatch } from "react-redux";
import { deleteFaqById, setFaqId, editFaq } from "../redux/actions/faqAction";
import { ToastContainer } from "./toast";
import { handleModal } from "../redux/actions/corfirmationModalAction";

const Faq = ({ item, setModalShow }) => {
  const dispatch = useDispatch();

  const setFaq = (faqId) => {
    dispatch(setFaqId(faqId, "edit"));
    setModalShow(true);
  };
  const handleDelete = async (faqId) => {
    let res = await dispatch(deleteFaqById(faqId));
    ToastContainer(res);
  };
  const handleEngageActive = async (faqId, status) => {
    let res = await dispatch(editFaq(faqId, status));
    ToastContainer(res);
  };
  const confirmationModal = (faqId) => {
    dispatch(
      handleModal({
        is_show: true,
        function: handleDelete,
        param: faqId,
      })
    );
  };
  return (
    <div className="card border-0">
      <div className="card-body">
        <div className="row align-items-center gx-5">
          <div className="col-auto">
            <a href="#" className="avatar @@active">
              <span className="avatar-text">
                {item?.title?.charAt(0).toUpperCase()}
              </span>
            </a>
          </div>
          <div className="col">
            <h5
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "200px",
              }}
            >
              <a
                style={{
                  textTransform: "capitalize",
                }}
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#modal-faq"
                onClick={() => setFaq(item?._id)}
              >
                {item?.title}
              </a>
            </h5>
            <p
              style={{
                textTransform: "capitalize",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "200px",
              }}
            >
              Department: {item?.department?.title}
            </p>
          </div>
          <div className="col-auto">
            <div className="dropdown">
              {!item?.is_engage_active && (
                <small>
                  <i
                    className="fal fa-ban"
                    style={{ color: "red", marginRight: "10px" }}
                  />
                </small>
              )}
              <a
                className="icon text-muted"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fal fa-ellipsis-v"></i>
              </a>
              <ul className="dropdown-menu">
                <li>
                  <a
                    className="dropdown-item"
                    style={{ cursor: "pointer" }}
                    onClick={() => setFaq(item?._id)}
                    // data-bs-toggle="modal"
                    // data-bs-target="#modal-faq"
                  >
                    Edit Article
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      handleEngageActive(item?._id, {
                        is_engage_active: !item?.is_engage_active,
                      })
                    }
                  >
                    {item?.is_engage_active ? `Pause` : `Active`}
                  </a>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <a
                    className="dropdown-item text-danger"
                    onClick={() => confirmationModal(item?._id)}
                    style={{ cursor: "pointer" }}
                  >
                    Delete Article
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default memo(Faq);
